export const aboutComparisonJa = {
  'about.problem.requires': '必要:',
  'about.problem.onlyfans.body': '月1万ドルのクリエイターは年間2万4千ドルを手数料で失います。',
  'about.problem.onlyfans.requires': '銀行口座 + KYC',
  'about.problem.throne.body': '為替換算手数料。出金遅延。10カ国に限定。',
  'about.problem.throne.requires': '銀行口座 + KYC',
  'about.problem.linktree.body': 'または月40ドルで0%手数料。いずれにせよ、あなたのお金を取られます。',
  'about.problem.linktree.requires': '銀行口座 + 決済プロセッサ',
  'about.problem.kickstarter.body': 'さらに5千〜2万5千ドルの履行コスト。オールオアナッシング資金調達。',
  'about.problem.kickstarter.requires': '銀行口座 + KYC + 履行',
  'about.problem.indiegogo.body': '配送まで5%保留。14日の支払い遅延。柔軟だが高コスト。',
  'about.problem.indiegogo.requires': '銀行口座 + KYC + 履行',
  'about.problem.katoa.body': '手数料なし。遅延なし。100%を保持（2026年12月31日まで）。',
  'about.problem.katoa.requires': '銀行口座不要。KYC不要。',
  'about.problem.avgLoss': '平均的なクリエイターの損失',
  'about.problem.avgLossAmount': '年間1万2千〜2万4千ドル',
  'about.problem.allRequire': '5つのプラットフォームすべてが必要:',
  'about.problem.bankAccount': '銀行口座',
  'about.problem.kyc': 'KYC本人確認',
  'about.problem.processors': '決済プロセッサ',
  'about.problem.geoLimits': '地理的制限',
  'about.problem.katoaRequires': 'KATOAに必要なもの: なし',
  'about.problem.katoaWallet': 'Bitcoin Lightningウォレットだけ。それだけです。',
  'about.solution.title': '私たちの解決策: Bitcoin + 分散化',
  'about.solution.subtitle': 'プラットフォーム手数料を不可能にする技術でKATOAを構築しました。',
  'about.solution.lightning.title': 'Lightning Network',
  'about.solution.lightning.body': 'BitcoinのLightning Networkは、Lightning受信の提供開始後、世界中で高速・低コストの取引を可能にします（Roadmap: 進行中）。手数料を取る決済業者なし。7日の遅延なし。地理的制限なし。',
  'about.solution.lightning.item1': '1秒未満での決済',
  'about.solution.lightning.item2': '195カ国以上で利用可能',
  'about.solution.lightning.item3': 'サトシ単位のマイクロペイメント',
  'about.solution.lightning.item4': '銀行口座不要',
  'about.solution.nostr.title': 'Nostrプロトコル',
  'about.solution.nostr.body': '検閲を不可能にする分散型ソーシャルプロトコル。あなたのアカウント、あなたのデータ、あなたのルール。企業があなたを追放したり情報を収集したりできません。',
  'about.solution.nostr.item1': 'アカウント停止なし（鍵はあなたのもの）',
  'about.solution.nostr.item2': '任意の暗号化メッセージ（NIP-17）',
  'about.solution.nostr.item3': 'ゼロ知識支払い証明（ロードマップ）',
  'about.solution.nostr.item4': '世界中のリレーに分散',
  'about.solution.result.title': '結果: 0%手数料（2026年12月31日まで）',
  'about.solution.result.body': 'Bitcoinでピアツーピアの支払いが流れるとき、手数料を取る仲介者はいません。プロモーション料金ではありません。技術の仕組みです。',
  'about.values.title': '私たちが大切にすること',
  'about.values.creators.title': 'クリエイター第一',
  'about.values.creators.desc': 'すべての決定はクリエイターの収益と自由を優先します。',
  'about.values.privacy.title': '常にプライバシー',
  'about.values.privacy.desc': '収集データは最小限。カストディなし。鍵はあなたのもの。',
  'about.values.global.title': '真のグローバル',
  'about.values.global.desc': '地理的差別なし。Bitcoinはすべての人のためにどこでも機能します。',
  'about.values.censorship.title': '検閲耐性',
  'about.values.censorship.desc': '設計上分散型。企業があなたを追放したりコンテンツを管理したりできません。',
  'about.competitors.title': 'すべての競合が劣る理由',
  'about.competitors.subtitle': '共通の根本的欠陥: 従来の銀行システムへの依存。',
  'about.competitors.onlyfans.title': 'OnlyFans: 20%プラットフォーム税',
  'about.competitors.onlyfans.body': '月1万ドルのクリエイターは月2千ドル（年2万4千ドル）を失います。Mastercard/Visaによる検閲リスク。異議申し立てのないアカウント停止。',
  'about.competitors.kickstarter.title': 'Kickstarter: 履行の悪夢',
  'about.competitors.kickstarter.body': 'プラットフォーム5%＋決済処理（合計は通常約8–10%）、さらに履行コスト5千〜2万5千ドル以上。目標未達なら0ドル。',
  'about.competitors.indiegogo.title': 'Indiegogo: 隠れた保留',
  'about.competitors.indiegogo.body': '配送まで5%保留を含む8-15%の総手数料。柔軟資金調達はお金を人質に取られるまで良く見えます。',
  'about.competitors.linktree.title': 'Linktree: 有料で勝つ収益化',
  'about.competitors.linktree.body': '無料枠: 10%手数料。または月40ドル（年480ドル）で0%。いずれにせよランディングページのために損をします。',
  'about.competitors.throne.title': 'Throne: 0%の計算',
  'about.competitors.throne.body': '「0%手数料」と宣伝するが、実際の合計は約10%。真の0%は約10カ国のみ。それ以外は差額を支払う。',
  'about.competitors.con.bankKyc': '銀行口座 + KYCが必要',
  'about.competitors.con.payout7': '7日の支払い遅延',
  'about.competitors.con.payout14': '14日以上の支払い遅延',
  'about.competitors.con.censorship': '決済プロセッサによる検閲',
  'about.competitors.con.countries': '対応国に限定',
  'about.competitors.con.fulfillment': '配送/履行のストレス',
  'about.competitors.con.oneTime': '一回限りの資金調達のみ',
  'about.competitors.con.holdback': '商品配送まで5%保留',
  'about.competitors.con.fulfillmentReq': '履行が必要',
  'about.competitors.con.processor': '決済プロセッサが必要',
  'about.competitors.con.geoRestrict': '地理的制限',
  'about.competitors.con.feesOrSub': '9-10%手数料または年480ドル',
  'about.competitors.con.countries50': '50カ国に限定',
  'about.competitors.con.withdraw7': '7日の出金遅延',
  'about.competitors.con.countries10': '0%は10カ国に限定',
  'about.competitors.con.conversion': '隠れた為替換算手数料',
  'about.competitors.katoa.title': 'KATOA: 唯一の真の代替',
  'about.competitors.katoa.body': 'Lightningのルーティング/ネットワーク手数料はサポーターが支払います。ウィンドウが終了する前に変更を公開します。',
  'about.competitors.katoa.fee': 'プラットフォーム手数料0%（2026年12月31日まで）',
  'about.competitors.katoa.feeDesc': 'Give A Bitとコミュニティの支援で運営',
  'about.competitors.katoa.payout': '高速払い出し（Roadmap）',
  'about.competitors.katoa.payoutDesc': 'Lightning経由 — 受信用途が可能になり次第（ロードマップ：進行中）。',
  'about.competitors.katoa.bank': '✓ 銀行不要',
  'about.competitors.katoa.bankDesc': 'Lightningウォレットだけ。',
  'about.competitors.katoa.global': '✓ 195カ国以上',
  'about.competitors.katoa.globalDesc': 'どこでも同じように機能。',
  'about.audience.title': '私たちが支える人',
  'about.audience.subtitle': 'KATOAは従来のプラットフォームが無視するクリエイターのために作られました。',
  'about.audience.unbanked.title': '銀行口座を持たない人',
  'about.audience.unbanked.body': 'アルゼンチン、ナイジェリア、ベネズエラ、ベトナムのクリエイター。StripeやPayPalが機能しない国。',
  'about.audience.unbanked.stat': '195カ国以上をサポート',
  'about.audience.privacy.title': 'プライバシー重視の人',
  'about.audience.privacy.body': '監視を拒否するクリエイター。エンドツーエンド暗号化を求める人。データ主権を要求する人。',
  'about.audience.privacy.stat': '最小データ、ノンカストディアル',
  'about.audience.ambitious.title': '野心的な人',
  'about.audience.ambitious.body': '月1万〜10万ドル以上を稼ぎ、10-20%の手数料にうんざりしているクリエイター。',
  'about.audience.ambitious.stat': '年間1万2千〜24万ドル節約',
  'about.team.title': 'クリエイターによる、クリエイターのための',
  'about.team.body1': 'プラットフォームに10-20%を失うことにうんざりしたクリエイターのチームです。だからより良いものを作りました。',
  'about.team.body2': 'ベンチャー資本はありません。成長至上主義の投資家に答えません。クリエイターに答えます。だから決して手数料は取りません。',
  'about.team.promise': '私たちの約束',
  'about.team.promise1': 'プラットフォーム手数料は決して取りません',
  'about.team.promise2': 'あなたのデータを収集しません',
  'about.team.promise3': '合法的なコンテンツでクリエイターを追放しません',
  'about.team.promise4': '常にあなたの収益を私たちより優先します',
  'about.cta.title': 'ムーブメントに参加',
  'about.cta.subtitle': 'まだ始まったばかり。参加して収益の100%を手元に — プラットフォーム手数料は0%（2026年12月31日まで）。',
  'about.cta.highlight': '次はあなた。',
  'about.cta.start': '100%の収益を始める',
  'about.cta.compare': '数字を見る',
  'about.cta.footer': '手数料なし。KYCなし。罠なし。100%をあなたが保持。',
  'comparison.badge': '正直な比較 • マーケティングなし',
  'comparison.earningsLabel': '月間収益（USD）',
  'comparison.savingsYearly': '月${amount}の収益に基づく — 年間${yearly}があなたのポケットに戻ります。',
  'comparison.savingsVs': 'vs OnlyFans (${onlyfans}) · Throne (${throne}) · Linktree (${linktree})',
  'comparison.adjustCalc': '計算機で調整 ↓',
  'comparison.breakdown.title': '機能別の詳細比較',
  'comparison.table.feature': '機能',
  'comparison.table.swipe': 'スワイプで続きを見る',
  'comparison.card.countries.title': '195カ国以上',
  'comparison.card.countries.body': '銀行口座なし？問題なし。Bitcoinはすべての人のためにどこでも機能します。差別なし。',
  'comparison.card.countries.throne': 'Throne: 0%手数料は約10カ国',
  'comparison.card.countries.katoa': 'KATOA: すべての国、0%（2026年12月31日まで）',
  'comparison.card.privacy.title': '真のプライバシー',
  'comparison.card.privacy.body': '収集データは最小限。カストディなし。暗号化メッセージは任意（NIP-17）。ゼロ知識証明はロードマップ。',
  'comparison.card.privacy.others': '他社: あなたのデータが商品',
  'comparison.card.privacy.katoa': 'KATOA: ノンカストディアル、最小データ',
  'comparison.card.instant.title': '高速決済（Roadmap）',
  'comparison.card.instant.body': '収益の100%を保持。グローバルに拡大。プラットフォーム税なしで帝国を築く。',
  'comparison.card.instant.others': '他社: 支払いまで7-14日待ち',
  'comparison.card.instant.katoa': 'KATOA: 即時Lightning Network（Lightning受信対応 — ロードマップ参照）',
  'comparison.cta.title': '100%を保持する準備はできましたか？',
  'comparison.cta.subtitle': '初期のクリエイターとして参加。プラットフォーム手数料0%。サポーターが送った分はあなたのもの。Lightningのネットワーク手数料は別途かかります。',
  'comparison.cta.start': '100%の収益を始める',
  'comparison.cta.pricing': '料金を見る（ネタバレ: $0）',
  'comparison.cat.fees': '手数料とコスト',
  'comparison.cat.banking': '銀行要件',
  'comparison.cat.global': 'グローバル展開',
  'comparison.cat.payout': '支払い速度',
  'comparison.cat.revenue': '収益モデル',
  'comparison.cat.privacy': 'プライバシーとセキュリティ',
  'comparison.cat.payment': '支払い機能',
  'comparison.cat.control': 'プラットフォーム管理',
  'comparison.feat.platformFees': 'プラットフォーム手数料',
  'comparison.feat.paymentProcessing': '決済処理',
  'comparison.feat.totalFee10k': '1万ドルの総手数料',
  'comparison.feat.monthlySub': '月額サブスクリプション',
  'comparison.feat.withdrawalFees': '出金手数料',
  'comparison.feat.hiddenCosts': '隠れたコスト',
  'comparison.feat.bankRequired': '銀行口座必須',
  'comparison.feat.kyc': 'KYC/本人確認',
  'comparison.feat.noBanking': '銀行なしで利用可能',
  'comparison.feat.processorDep': '決済プロセッサ依存',
  'comparison.feat.countries': '対応国',
  'comparison.feat.sanctioned': 'Bitcoinはグローバル',
  'comparison.feat.instantIntl': '高速国際送金（Roadmap）',
  'comparison.feat.conversion': '為替換算手数料',
  'comparison.feat.payoutTime': '支払い時間',
  'comparison.feat.instantSettlement': '高速決済（Roadmap）',
  'comparison.feat.holdback': '資金保留',
  'comparison.feat.crowdfunding': 'クラウドファンディング/プロジェクト',
  'comparison.feat.subscriptions': 'サブスクリプション（デモ）',
  'comparison.feat.tips': 'チップ/寄付',
  'comparison.feat.digital': 'デジタル商品',
  'comparison.feat.fulfillment': '履行が必要',
  'comparison.feat.zk': 'ゼロ知識証明（ロードマップ）',
  'comparison.feat.encrypted': '暗号化メッセージ（NIP-17任意）',
  'comparison.feat.decentralized': '分散インフラ',
  'comparison.feat.censorship': '検閲耐性',
  'comparison.feat.micro': 'マイクロペイメント対応',
  'comparison.feat.bolt12': 'BOLT 12定期支払い（予定）',
  'comparison.feat.lightning': 'Lightning Network',
  'comparison.feat.multiRevenue': '複数の収益源',
  'comparison.feat.suspension': 'アカウント停止リスク',
  'comparison.feat.contentCensor': 'コンテンツ検閲',
  'comparison.feat.ownData': 'データを所有',
  'comparison.feat.ownKeys': '鍵を所有',

  'comparison.cell.instant': '高速',
  'comparison.cell.none': 'なし',
  'comparison.cell.varies': '場合による',
  'comparison.cell.included': '含まれる',
  'comparison.cell.limited': '限定',
  'comparison.cell.demo': 'デモ',
  'comparison.cell.planned': '予定',
  'comparison.cell.roadmap': 'ロードマップ',

  'comparison.metaTitle': 'プラットフォーム比較',
  'comparison.metaDesc': 'KATOAとOnlyFans、Throne、Kickstarterなどを比較。プラットフォーム手数料0%、Lightning着金、開始時にKYCなし。',
} as const;